import React from 'react';
export function HookSection() {
  return <section className="py-20 bg-[#1B5E5E] text-white relative" data-id="element-105">
      <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center" data-id="element-106">
        <h2 className="text-3xl md:text-4xl font-bold mb-10 text-white leading-tight" data-id="element-107">
          ¿Alguna vez has dudado antes de bajar el primer escalón de la mañana?
        </h2>

        <div className="space-y-8 text-xl md:text-2xl leading-relaxed text-white/90 font-sans" data-id="element-108">
          <p data-id="element-109">
            Ese "pinchazo" agudo que te obliga a apoyarte en la pared no es solo
            vejez.{' '}
            <strong className="text-[#C9A84C] font-semibold" data-id="element-110">
              Es una señal de auxilio de tus articulaciones.
            </strong>
          </p>

          <p data-id="element-111">
            No tienes por qué aceptar vivir con miedo a caerte o resignarte a
            perder tu independencia. Tus rodillas no están "gastadas",
            simplemente están{' '}
            <span className="underline decoration-[#C9A84C] decoration-4 underline-offset-4" data-id="element-112">
              secas de su lubricante natural
            </span>
            .
          </p>
        </div>

        <div className="mt-12 rounded-2xl overflow-hidden shadow-lg max-w-2xl mx-auto" data-id="element-113">
          <img src="https://cdn.magicpatterns.com/uploads/4fp2RUoSbXMv8uQXVnXBm9/section-97583.png" alt="Beneficios Clave del Protocolo de 21 Días" className="w-full h-auto object-cover" data-id="element-114" />
        </div>
      </div>
    </section>;
}